import React,{ useRef }  from 'react'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import {  Autoplay } from 'swiper/modules';
import 'swiper/css';
import {
    Wrapper,
    SubHeading,
    CarouselWrapper,
    NavigationButtons,
    NavButton,
    SlideContainer,
    Image,
    CategoryBadge,
    SlideContent,
    SlideLink,
    SlideTitle,
    SlideDescription,
    SourceDate,
    BreakSpan,
    ViewAllButtonWrapper,

  } from '../styles/InNewsStyles';
import { Title } from '../styles/AchievementsStyle';

const news = [
    {
        id: 1,
        title: "Why Are People Investing in Luxury Homes in Risk Zones?",
        description: "Despite increasing risks of flooding and erosion, high-end properties in these areas continue to attract buyers.",
        category: "press",
        source: "Real Estate Insights",
        date: "December 20, 2024",
        image: "/assets/images/house1.avif"
    },
    {
        id: 2,
        title: "The Future of Smart Homes: Revolutionizing Real Estate",
        description: "With the rise of IoT devices, smart homes are becoming more popular, and they're reshaping the real estate market.",
        category: "news",
        source: "Tech Real Estate Daily",
        date: "December 19, 2024",
        image: "/assets/images/img1.jpg"
    },
    {
        id: 3,
        title: "How Remote Work is Changing Housing Demand",
        description: "The shift to remote work is increasing the demand for homes in suburban and rural areas as people seek more space.",
        category: "blog",
        source: "Work From Home Times",
        date: "December 18, 2024",
        image: "/assets/images/img2.jpg"
    },
    {
        id: 4,
        title: "Real Estate Investment Tips for 2025",
        description: "Experts share their top advice for investing in real estate in the upcoming year, focusing on emerging markets and trends.",
        category: "guide",
        source: "Investor's Hub",
        date: "December 17, 2024",
        image: "/assets/images/house2.avif"
    },
    {
        id: 5,
        title: "The Impact of Rising Interest Rates on Housing Prices",
        description: "How increased interest rates are affecting property prices and what buyers should expect in the coming months.",
        category: "news",
        source: "Housing Market Weekly",
        date: "December 16, 2024",
        image: "/assets/images/img3.jpg"
    },
    {
        id: 6,
        title: "Sustainable Architecture: A Growing Trend in Luxury Real Estate",
        description: "Sustainable and eco-friendly designs are becoming a top priority in luxury homes, attracting environmentally-conscious buyers.",
        category: "press",
        source: "Eco Homes Today",
        date: "December 15, 2024",
        image: "/assets/images/img4.jpg"
    }
];



const InNews = () => {
    const swiperRef = useRef(null); 

    const handleNext = () => {
        if (swiperRef.current) {
            swiperRef.current.slideNext(); 
        }
    };

    const handlePrevious = () => {
        if (swiperRef.current) {
            swiperRef.current.slidePrev();
        }
    };

    return (
        <Wrapper>
      <Title>In The News</Title>
      <SubHeading>See our latest press mentions.</SubHeading>
      <CarouselWrapper>
        <NavigationButtons>
          <NavButton onClick={handlePrevious}>Previous</NavButton>
          <NavButton onClick={handleNext}>Next</NavButton>
        </NavigationButtons>

        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          modules={[Autoplay]}
          loop
          slidesPerView={3}
          spaceBetween={30}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1920: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1028: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
          }}
        >
          {news.map((item) => (
            <SwiperSlide key={item.id}>
              <SlideContainer>
                <Image src={item.image} alt={item.category} />
                <CategoryBadge>{item.category}</CategoryBadge>
                <SlideContent>
                  <SlideLink href="#home">
                    <SlideTitle>{item.title}</SlideTitle>
                  </SlideLink>
                  <SlideDescription>{item.description}</SlideDescription>
                  <SourceDate>
                    {item.source} | <BreakSpan>{item.date}</BreakSpan>
                  </SourceDate>
                </SlideContent>
              </SlideContainer>
            </SwiperSlide>
          ))}
        </Swiper>

        <ViewAllButtonWrapper>
          <Link to="/inTheNews" className='border border-black text-black no-underline py-3 px-4 uppercase font-semibold transition duration-300 ease-in-out hover:bg-gray-900 hover:!text-white'>View All</Link>
        </ViewAllButtonWrapper>
      </CarouselWrapper>
    </Wrapper>

    )
}

export default InNews